import React, { useState, useEffect } from "react";
import { duration } from "../../helpers/duration-helpers";
import * as styles from "./style.mod.scss";
import locale from "locales";

const Countdown = ({ data }) => {
  if (!data) return<></>;
  let interval = null;
  const countdownLoc = locale.countdown;
  const { date, show } = data;

  const [timeLeft, setTimeLeft] = useState(duration(`${date}`));

  useEffect(() => {
    interval = setInterval(() => {
      setTimeLeft(duration(`${date}`));
        
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const { days, hours, minutes, seconds } = timeLeft;

  if (days === 0 && hours === 0 && minutes === 0 && seconds === 0) {
    clearInterval(interval);
  }

  return (
    <>
      {show &&
        <div className={styles.timer}>
          {(days > 0 || hours > 0 || minutes > 0 || seconds > 0) && (
            <>
              <div className={styles.countdownTitle}>
                <p>{countdownLoc.title}</p> 
              </div>
              <div className={styles.countdownContainer}>
                <div className={styles.countdown}>
                  <div className={styles.container}>
                    <span className={styles.number}>
                      {days.toFixed(0).padStart(2, "0")}
                    </span>
                    <span className={styles.text}>{countdownLoc.day}</span>
                  </div> 
                  <div className={styles.dots}>
                    <span></span>
                    <span></span>
                  </div>
                  <div className={styles.container}>
                    <span className={styles.number}>
                      {hours.toFixed(0).padStart(2, "0")}
                    </span>
                    <span className={styles.text}>{countdownLoc.hour}</span>
                  </div>
                  <div className={styles.dots}>
                    <span></span>
                    <span></span>
                  </div>
                  <div className={styles.container}>
                    <span className={styles.number}>
                      {minutes.toFixed(0).padStart(2, "0")}
                    </span>
                    <span className={styles.text}>{countdownLoc.minute}</span>
                  </div>
                  <div className={styles.dots}>
                    <span></span>
                    <span></span>
                  </div>
                  <div className={styles.container}>
                    <span className={styles.number}>
                      {seconds.toFixed(0).padStart(2, "0")}
                    </span>
                    <span className={styles.text}>{countdownLoc.second}</span>
                  </div>
                </div>
              </div>
            </>
          )}
            
        </div>
      }
    </>
  );
};

export default Countdown;
